import React from 'react';
import { ProductCardList } from '@wix/premium-purchase-platform/@components';
import {
  useCurrentModule,
  useProductFeatures,
} from '@wix/package-picker-shared-eclipse';
import { ProductCardFeatureRow } from './ProductCardFeatureRow';
import { ProductCardFeatureRowWithDescription } from './ProductCardFeatureRowWithDescription';
import { Box } from '@wix/design-system';

export const FeatureList = ({ productId }: { productId: string }) => {
  const module = useCurrentModule();
  const { experiments } = module.internals.experiments.hooks.useExperiments();
  const isFeatureDescriptionEnabled = experiments.isEnabled(
    'specs.premium.premiumEclipseFeatureDescription',
  );
  const { features } = useProductFeatures({ productId });


  if (!features || !Array.isArray(features) || features.length === 0) {
    return null;
  }

  return (
    <Box direction="vertical" width="100%">
      <ProductCardList.Default.Card.FeatureList
        boxSizing="border-box"
        gap="16px"
        verticalAlign="top"
        renderRow={(row) =>
          isFeatureDescriptionEnabled ? (
            <ProductCardFeatureRowWithDescription row={row} />
          ) : (
            <ProductCardFeatureRow row={row} />
          )
        }
        features={features ?? []}
      />
    </Box>
  );
};
